namespace Solovis.Reports.Parameters {

    export type ForwardPeriodsPeriodType = "Months" | "Quarters";
    export type ForwardPeriodsValue = { number: number; select: ForwardPeriodsPeriodType };

    export class ForwardPeriodsParameterControl extends Solovis.UI.BaseControl {
        public static hasNewRender = true;

        private _currentValue: ForwardPeriodsValue;

        constructor(options) {
            super(options);

            this._currentValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
        }

        public static getLabel(value: ForwardPeriodsValue): string | undefined {
            if (!value || value.number == null || !value.select) {
                return undefined;
            }
            return value.number + " " + value.select;
        }

        public doInit() {
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        private async doRenderNew() {
            await Solovis.UX.Utils.placeComponent("ConfigureControl", this.container[0], {
                onClick: () => this._showForwardPeriodsEditor()
            });
        }

        // Report Stack Building renders parameter controls in classic mode, where other
        // configurable parameters (e.g. TimePeriods) use a plain "Configure" link rather
        // than the modern ConfigureControl. Match that so the two look consistent there.
        private doRenderClassic() {
            const self = this;
            const configureLink = $("<a>").text("Configure").appendTo(this.container);
            configureLink.click(function () { self._showForwardPeriodsEditor(); });
        }

        private _showForwardPeriodsEditor() {
            Solovis.UX.Utils.renderModal("ForwardPeriodsEditor", {
                initialValue: this._currentValue,
                onSubmit: (newValue: ForwardPeriodsValue) => {
                    this._currentValue = newValue;
                    this.notifyParameterValueChanged();
                },
                onClose: () => { }
            }, this.container[0]);
        }

        public setParameterValue(newValue: ForwardPeriodsValue) {
            this._currentValue = newValue;
        }

        public getParameterValue() {
            return this._currentValue ? Solovis.deepCopy(this._currentValue) : null;
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }
    }
}
